import { render, staticRenderFns } from "./myWishes.vue?vue&type=template&id=4aab1abe&scoped=true&"
import script from "./myWishes.vue?vue&type=script&lang=js&"
export * from "./myWishes.vue?vue&type=script&lang=js&"
import style0 from "./myWishes.vue?vue&type=style&index=0&id=4aab1abe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aab1abe",
  null
  
)

export default component.exports